/* Created by gparap (c) 2022 */

import './App.css';
import Calculator from './components/Calculator'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Calculator />
      </header>
      <Router basename="/projects/react/calculator-basic">
				    <Routes>
					    <Route path='/' element={<App />} />
					    {/* Add more routes if needed */}
				    </Routes>
			    </Router>
    </div>
  );
}

export default App;
